module.exports = __webpack_public_path__ + "static/media/auth-bg.5d0f0ddd.jpg";